import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogActionsEnum, DialogComponent} from 'appShared/components';
import {FormInterface} from 'appShared/interfaces';
import {MatDialogRef} from '@angular/material/dialog';
import {FormComponent} from 'appShared/widgets';
import {CreateSubscriptionForm, UpdateSubscriptionForm} from 'appEntries/panel/forms';
import {ApiError, HttpStatusCodesEnum, ServerResponseData} from '@spa/api';
import {Subscription} from 'rxjs';
import {ApiResponse} from '@spa/api/lib/common';

@Component({
    template: ''
})
export abstract class PanelBaseMarketDataDialogComponent<DataType = any>
    extends DialogComponent<DataType> implements OnInit, OnDestroy, FormInterface {
    protected subscriptions: Subscription[];
    public form: UpdateSubscriptionForm | CreateSubscriptionForm;
    public isServiceUser: boolean;

    constructor(dialogRef: MatDialogRef<DataType>) {
        super(dialogRef);
        this.subscriptions = [];
    }

    abstract handleErrorResponse(response: ApiResponse<ApiError[] | boolean>): void;

    abstract showSuccessFormMessage(): void;

    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        this.form.initForm();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
    }

    getPlaceholderData(placeholder: string, splitIndex: number): string {
        return placeholder.split('-')[splitIndex];
    }

    getFormMessages(controlLabel?: string): { [p: string]: string } {
        return FormComponent.getFormMessages(controlLabel);
    }

    validateForm(): boolean {
        return this.form.validateForm(this.getFormMessages);
    }

    onFormSubmit(action?: number): void {
        if (action !== DialogActionsEnum.Confirm) {
            this.dialogRef.close(false);

            return;
        }

        if (this.validateForm()) {
            const requestSubscription = this.form.createRequest()
            .subscribe((response: ServerResponseData<boolean>) => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    this.handleErrorResponse(response);

                    return;
                }

                this.dialogRef.close(true);
                this.showSuccessFormMessage();
            });

            this.subscriptions.push(requestSubscription);
        }
    }
}
